export const UPDATE_FORM_VALUES = Symbol('auth/userInfoForm/UPDATE_FORM_VALUES');

export const UPDATE_FORM_VALIDATION = Symbol('auth/userInfoForm/UPDATE_FORM_VALIDATION');
export const RESET_FORM_VALIDATION = Symbol('auth/userInfoForm/RESET_FORM_VALIDATION');

export const RESET_FORM = Symbol('auth/userInfoForm/RESET_FORM');
